// Archetype imagery (from design guidelines)
export const ARCHETYPE_IMAGES = {
  merpati: "https://images.unsplash.com/photo-1752775363929-7aafdda54e47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxkb3ZlJTIwYmlyZCUyMG1pbmltYWxpc3R8ZW58MHx8fHwxNzg2NTQ3NjA0fDA&ixlib=rb-4.1.0&q=85",
  helang: "https://images.unsplash.com/photo-1572254939712-70b5a7f82769?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxlYWdsZSUyMGJpcmQlMjBmbHlpbmclMjBza3l8ZW58MHx8fHwxNzg2NTQ3NjA0fDA&ixlib=rb-4.1.0&q=85",
  burung_hantu: "https://images.unsplash.com/photo-1628126907372-761f54441c1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxvd2wlMjBiaXJkJTIwbmF0dXJlfGVufDB8fHx8MTc4NjU0NzYwNHww&ixlib=rb-4.1.0&q=85",
  merak: "https://images.unsplash.com/photo-1559048958-4d1a3dc247d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwZWFjb2NrJTIwYmlyZCUyMGJlYXV0aWZ1bHxlbnwwfHx8fDE3ODY1NDc2MDR8MA&ixlib=rb-4.1.0&q=85",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1543286386-2e659306cd6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMGdyb3d0aCUyMGFic3RyYWN0fGVufDB8fHx8MTc4NjU0NzYwNHww&ixlib=rb-4.1.0&q=85";

export const INDUSTRIES = [
  "Makanan & Minuman (F&B)",
  "Runcit & E-dagang",
  "Perkhidmatan",
  "Kecantikan & Kesihatan",
  "Fesyen & Pakaian",
  "Pendidikan & Latihan",
  "Teknologi",
  "Pembuatan",
  "Pertanian",
  "Lain-lain",
];

export const TEMPOH = [
  "Kurang 1 tahun",
  "1 – 3 tahun",
  "3 – 5 tahun",
  "5 – 10 tahun",
  "Lebih 10 tahun",
];

export const GENDERS = ["Perempuan", "Lelaki", "Tidak mahu nyatakan"];

export const AGE_RANGES = [
  "Bawah 18",
  "18–24",
  "25–34",
  "35–44",
  "45–54",
  "55–64",
  "65+",
];

export const BUSINESS_ROLES = [
  "Pemilik Bisnes",
  "Solopreneur",
  "Freelancer",
  "Profesional",
  "Pengurus",
  "Side Hustle / Separuh Masa",
  "Lain-lain",
];

export const BUSINESS_MODELS = [
  "Runcit Fizikal",
  "Bisnes Perkhidmatan",
  "Amalan Profesional",
  "Makanan & Minuman",
  "Online / E-dagang",
  "Pendidikan / Latihan",
  "Pembuatan",
  "Agensi / Perundingan",
  "Freelancer / Solopreneur",
  "Lain-lain",
];

export const EMPLOYEE_COUNTS = [
  "Hanya saya",
  "2–5",
  "6–20",
  "21–50",
  "Lebih 50",
];

export const REVENUE_RANGES = [
  "Bawah RM5,000",
  "RM5,000–RM20,000",
  "RM20,000–RM50,000",
  "RM50,000–RM200,000",
  "Lebih RM200,000",
];
